import { MaterialEntry } from '../material/MaterialEntry';
import { TriggerData } from '../trigger/TriggerData.model';
import { DocumentGroupModel } from '../document/document-group.model';
import { ChecklistTemplateReferenceJobRoutineDTO } from "../checklist-template/ChecklistTemplateReferenceJobRoutineDTO";
import { JobRoutineType } from '../../enums/job_template/job-routine-type.enum';
import { JobTemplateConditionType } from '../../enums/job_template/JobTemplateConditionType';

export class JobTemplateCreationModel {
  id: string;
  type: JobRoutineType;
  componentId: string;
  parentId: string;
  assigneeUserId: string;
  assigneeGroupId: string;
  serviceProviderId: string;
  isActive: boolean;
  groupId: string;
  triggerData: TriggerData[];
  plannedWorkingTime: number;
  selectedChecklistTemplateIds: string[];

  name: string;
  description: string;
  flatRate: string;
  producerNumber: string;

  jobType: string;
  jobTypeId: string;
  price: number;
  documents: DocumentGroupModel[];

  materials: MaterialEntry[];
  moduleId: string;
  fromModuleId: string; //if a routines was created of an module-job-template.

  priorityOrder: number; //Frontend implementation
  plannedExecutionAmount: number;
  jobTemplateConditionType: string;
  plannedStandStillTime: number;
  standstill: boolean;
  isPinned: boolean = false;
  isIdentical: boolean = true;
  jobBeginStatus: number;
  plannedImplDuration: number;

  inHouseExecution: boolean;
  externExecutionSpId: string;

  checklistTemplateReferences: ChecklistTemplateReferenceJobRoutineDTO[];

  constructor(componentId: string, parentId: string, assigneeUserId: string, assigneeGroupId: string,
              serviceProviderId: string, isActive: boolean, groupId: string, triggerData: TriggerData[], plannedWorkingTime: number, name: string,
              description: string, jobType: string, price: number, documents: DocumentGroupModel[], materials: MaterialEntry[],
              plannedExecutionAmount, plannedImplDuration: number, standstill: boolean, isIdentical: boolean, jobBeginStatus: number,
              jobTemplateConditionType: JobTemplateConditionType, type: JobRoutineType) {
    this.componentId = componentId;
    this.parentId = parentId;
    this.assigneeUserId = assigneeUserId;
    this.assigneeGroupId = assigneeGroupId;
    this.serviceProviderId = serviceProviderId;
    this.isActive = isActive;
    this.groupId = groupId;
    this.triggerData = triggerData;
    this.plannedWorkingTime = plannedWorkingTime;
    this.name = name;
    this.description = description;
    this.jobTypeId = jobType;
    this.price = price;
    this.documents = documents;
    this.materials = materials;
    this.plannedExecutionAmount = plannedExecutionAmount;
    this.plannedImplDuration = plannedImplDuration;
    this.standstill = standstill;
    this.isIdentical = isIdentical;
    this.jobBeginStatus = jobBeginStatus;
    this.jobTemplateConditionType = jobTemplateConditionType;
    this.type = type;
  }

  static empty(): JobTemplateCreationModel {
    return new JobTemplateCreationModel(null, null, null, null, null, false, null, [], 0, '', '', null, 0, [], [], null, null, false, false, 1, null, JobRoutineType.DEFAULT);
  }
}
